import { FC } from 'react'
import Link from 'next/link'

import styles from './course-btn-back.module.scss'

interface ICourseBtnBack {
  txt?: string
  link?: string
}

const CourseBtnBack: FC<ICourseBtnBack> = ({ txt = 'Ко всем курсам', link = '/program' }) => {
  return (
    <Link href={link}>
      <div className={styles.container}>
        <span className={styles.arrow}></span>
        <p>{txt}</p>
      </div>
    </Link>
  )
}

export default CourseBtnBack
